import { Box, Button, Container, TextField } from '@mui/material'
import { Booking } from './booking/Index'
import { Product } from './product/Index'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import { useContext } from 'react'
import { ToolContext } from '../../../core/context/ToolContext'

export const ReviewRatings = ({match}) => {
    const { reviews_state } = useContext(ToolContext)
    const { search } = reviews_state
    const history = useHistory()
    const typeParams = match.params.type

    const handlerBtns = (type) => {
        search.set('')
        history.push(type)
    }
    
    return (
        <Container maxWidth="xl" sx={{py: '16px', display: 'flex', flexDirection: 'column', gap: '24px', height: '100%', width: '100%'}}>
            <Box fontSize="1.375rem" fontWeight={700}>
                Reviews and Ratings
            </Box>
            <Box display="flex" justifyContent="space-between">
                <Box display="flex" gap="24px" >
                    <Box component={Button} variant='outlined' width={150} borderRadius="12px" onClick={() => handlerBtns('service')}
                        color={typeParams === 'service' ? '#fff' :'#000'}
                        bgcolor={typeParams === 'service' ? '#009F4D' :'#fff'}
                        sx={{':hover': { bgcolor: typeParams === 'service' ? '#009F4D' :'#fff' } }}
                    >
                        Booking
                    </Box>
                    <Box component={Button} variant='outlined' width={150} borderRadius="12px"  onClick={() => handlerBtns('product')}
                        color={typeParams === 'product' ? '#fff' :'#000'}
                        bgcolor={typeParams === 'product' ? '#009F4D' :'#fff'}
                        sx={{':hover': { bgcolor: typeParams === 'product' ? '#009F4D' :'#fff' } }}
                    >
                        Product
                    </Box>
                </Box>
                <Box>
                    <TextField size='small' placeholder="Search" onChange={(e) => search.set(e.target.value)} />
                </Box>
            </Box>
            {
                typeParams === 'service' ?
                    <Booking />
                :
                    <Product />
            }
        </Container>
    )
}
